import Vue from 'vue'
import Router from 'vue-router'
import activity from './activity'
import user from './user'
import curriculum from './curriculum'
import coupon from './coupon'
import salesman from './salesman'
import vip from './vip';
Vue.use(Router)

export default new Router({
  routes: [
    // 活动的路由
    ...activity,
    // 课程路由
    ...curriculum,
    // 用户的路由
    ...user,
    // 优惠券
    ...coupon,
    // 业务员
    ...salesman,
    ...vip
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js